import React from "react";

export const Process = () => {
    return (
        <div className="solution" id="process"> 
	<div className="container">
		<div className="row">
			
			<div className="col-md-7">
				<div className="filter">
					<div className="filter-img"><img src="img/call.png" className="img-fluid" alt="ro repair water purifier" /></div>
					 
				</div>
			</div>

			<div className="col-md-5">
				<h3>How <strong>Water Purifier Services Process </strong> Work ?</h3>
				<div className="sernum">
                    <div className="number">1</div>
					<div className="para">Book Water Purifier Services by calling us / filling the Enquiry form. </div>
				</div>

				<div className="sernum">
                    <div className="number">2</div>
					<div className="para">Get technician confirmation call. </div>
				</div>

				<div className="sernum">
                    <div className="number">3</div>
					<div className="para">Schedule your service. </div>
				</div>

				<div className="sernum">
                    <div className="number">4</div>
					<div className="para">Technician will visit at your place. </div>
				</div>

				<div className="sernum">
					<div className="number">5</div>
					<div className="para">Service will be done. </div>
				</div>

				<div className="sernum">
                    <div className="number">6</div>
					<div className="para">Make payment and share your valuable feedback. </div>
				</div>

				 
			</div>

		</div>
	</div>
</div>
    )
}